import API from "./api";

// ✅ Get all customers
export const getCustomers = async () => {
    try {
        const response = await API.get("/customers");
        return response.data;
    } catch (error) {
        console.error("Error fetching customers:", error.response?.data || error.message);
        throw error;
    }
};

// ✅ Get a single customer by NIC
export const getCustomerByNIC = async (nic) => {
    try {
        const response = await API.get(`/customers/${nic}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching customer:", error);
        throw error;
    }
};

// ✅ Register a new customer
export const registerCustomer = async (customerData) => {
    try {
        const response = await API.post("/customers/register", customerData, {
            headers: { "Content-Type": "application/json" },
        });
        return response.data;
    } catch (error) {
        console.error("Error registering customer:", error.response?.data || error.message);
        throw error.response?.data || { message: "Registration failed!" };
    }
};

// ✅ Update customer details (Fixed API route)
export const updateCustomer = async (nic, updatedData) => {
    if (!nic) {
        console.error("Error: NIC is missing in API call!");
        throw new Error("NIC is required for update.");
    }

    console.log(`Updating customer with NIC: ${nic}`, updatedData); // ✅ Debugging

    try {
        const response = await API.put(`/customers/${nic}`, updatedData, {
            headers: { "Content-Type": "application/json" },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating customer (${nic}):`, error);
        throw new Error(error.response?.data?.message || "Customer update failed.");
    }
};


// ✅ Delete a customer
export const deleteCustomer = async (nic) => {
    try {
        const response = await API.delete(`/customers/${nic}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting customer:", error);
        throw error;
    }
};
